import React, {useContext} from 'react';
import {Card, ListGroup, Dropdown, Button} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash, faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import {useParams} from 'react-router-dom';
import {useNavigate} from 'react-router';
import './ChantierInfoNote.css';
import {MadricContext} from '../../../Context/MadricContext';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function ChantierInfoNoteView(props) {
  const navigate = useNavigate();
  const {id} = useParams();
  const returnTo = 'pasHistorique'
  const {listeEmploye} = useContext(MadricContext);

  return (
    <React.Fragment>
      <Button
        style={{backgroundColor: '#212529', color: 'white', marginBottom: '15px'}}
        onClick={props.addNote}>
        Ajouter une note
      </Button>
      <div className="chantierheure-filter-container">

        <Dropdown >
          <Dropdown.Toggle
            className="chantierheure-form-control"
            style={{
              backgroundColor: 'white',
              marginTop: '0px',
              marginLeft: '0px',
              color: 'black',
              height: '47px',
              border: '2px solid black',
            }}>
            {props.inputRef.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {listeEmploye.map((user, index) => {
              return <Dropdown.Item key={index} onClick={() => props.handleChange(user)}>{user.label}</Dropdown.Item>;
            })}
          </Dropdown.Menu>
        </Dropdown>
        <DatePicker
          className="chantierheure-form-control"
          type="date"
          selected={props.dateRef}
          onChange={props.handleDateChange}
          placeholderText="Filtrer par date"
          dateFormat="dd-MM-yyyy" />
        <FontAwesomeIcon
          className="chantierheure-trash-icon"
          icon={faTrash}
          onClick={() => props.removeDate()} />
      </div>
      <div className="chantierheure-filter-container">
        <DatePicker
          className="chantierheure-form-control2"
          type="text"
          selected={props.dateRef}
          onChange={props.handleDateChange}
          placeholderText="Filtrer par date"
          dateFormat="dd-MM-yyyy" />
        <FontAwesomeIcon
          className="chantierheure-trash-icon2"
          icon={faTrash}
          onClick={() => props.removeDate()} />
      </div>

      <div style={{marginBottom: '40px'}}>
        <MDBCheckbox name='extra1' label='Extra possible' inline onChange={props.handleCheckboxChange}/>
        {localStorage.getItem('admin') === '1' ?
            <React.Fragment>
              <MDBCheckbox name='extra2' label='Extra valider' inline onChange={props.handleCheckboxChange} />
              <MDBCheckbox name='extra3' label='Extra confirmer' inline onChange={props.handleCheckboxChange}/>
            </React.Fragment> : '' }
      </div>


      {props.filteredArray.map((note, index) => (
        <div className="checkin-container" key={note.id}>
          <Card className="checkin-card">
            <Card.Header className="checkin-header">{props.formatDate(note.date)}
              <button className="checkin-pagination-button float-end" onClick={() => navigate('/UpdateNote', {state: {note, id, returnTo}})}><FontAwesomeIcon icon={faPencilAlt} /></button>
            </Card.Header>
            <ListGroup variant="flush">
              <ListGroup.Item className="checkin-list-item">Note: {note.note}</ListGroup.Item>
              <ListGroup.Item>
                <MDBCheckbox name='inlineCheck' id='inlineCheckbox111' checked={note.extra1} label='Extra possible' disabled inline />
                {localStorage.getItem('admin') === '1' ?
            <React.Fragment>
              <MDBCheckbox name='inlineCheck' id='inlineCheckbox222' checked={note.extra2} label='Extra valider' disabled inline />
              <MDBCheckbox name='inlineCheck' id='inlineCheckbox333' checked={note.extra3} label='Extra confirmer' disabled inline />
            </React.Fragment> : ' ' }

              </ListGroup.Item>
              <ListGroup.Item className="checkin-list-item">Employé: {note.user_name}</ListGroup.Item>
            </ListGroup>

          </Card>
        </div>
      ))}
    </React.Fragment>
  );
}

export default ChantierInfoNoteView;
